import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { VehiculosExclusionEntity, CabeceraVehiculosExclusionEntity } from "../entities/vehiculos_exclusion_entity";
import { DetalleVehiculoEntity } from "../../masivos/datosGenerales/entities/detalle_vehiculo_entity";

declare var jQuery: any;

@Injectable()
export class ExclusionVehiculosService {
    sesionStorageService: any;
    private url = "solicitudes";


    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaVehiculos(poliza: PolizaEntity): Observable<any> {                
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaVehiculosAExcluir", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    excluirVehiculos(vehiculos: CabeceraVehiculosExclusionEntity): Observable<any> {                
        let body = JSON.stringify(vehiculos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/excluirVehiculos", body, options).map(this.extractData)
            .catch(this.handleError);
    }  
    incluirVehiculos(vehiculos: DetalleVehiculoEntity) {                
        let body = JSON.stringify(vehiculos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/solicitarInclusionVehSinAdjuntos", body, options).map(this.extractData)
            .catch(this.handleError);
    }   
        
      

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-vehiculos.service.ts